<template>
  <div class="grid grid-cols-12 col-span-12">
    <div class="col-span-3 p-8 pt-16 lg:p-12 bg-transaction-gradient">
      <BaseButton theme="white-bordered"
                  class="flex items-center hover:text-red w-full"
                  @click="$router.push({name:'banks-integrations'})">
        <IconCog class="mr-4 text-text-ternary"/>
        {{ $t('settings') }}
      </BaseButton>
    </div>
    <div class="col-span-9 p-8 pt-16 lg:p-12
                grid grid-cols-3 col-gap-6 row-gap-6 items-center">
      <template v-if="connections.length">
        <MKBankButton v-for="(connection,i) in connections" :key="`connection-${i}`"
                      :icon="connection.bank.icon"
                      :logo="connection.bank.logo_url"
                      :name="connection.bank.alias || connection.bank.name"
                      :background="connection.bank.color_bg"
                      :color="connection.bank.color_text"
                      :next-refresh-at="connection.next_refresh_at"
                      :disabled="disableButtons"
                      @click="refreshConnectionProvider(connection)"/>
      </template>
      <div v-else class="text-lg text-text font-bold col-span-3">
        {{ $t('emptyTip') }}
      </div>
    </div>
    <SaltEdgeModal v-if="!!saltEdgeLink"
                   :salt-edge-link="saltEdgeLink"
                   @close="handleCloseModal"/>
    <RedirectModal v-if="!!redirectLink"
                   :redirect-link="redirectLink"
                   @close="handleCloseModal"/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {bank} from "@/utilities/bank_types";
import IconCog from "@/components/icons/IconCog";
import BaseButton from "@/components/UI/BaseButton";
import MKBankButton from "@/components/common/MKBankButton";
import SaltEdgeModal from "@/components/cabinet/SpaceSettings/BanksIntegrations/SaltEdgeModal";
import RedirectModal from "@/components/cabinet/SpaceSettings/BanksIntegrations/RedirectModal";

export default {
  name: "SynchronizeBanks",
  components: {RedirectModal, SaltEdgeModal, MKBankButton, IconCog, BaseButton},
  data() {
    return {
      saltEdgeLink: null,
      redirectLink: null,
      disableButtons: false
    }
  },
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    ...mapState('space/banks', {
      connections: (state) => state.providers.data
    }),
  },
  methods: {
    ...mapActions('space/banks', ['refreshProvider']),
    async refreshConnectionProvider(connection) {
      try {
        this.disableButtons = true;
        const res = await this.refreshProvider({space_id: this.spaceInfo.id, connection_id: connection.id})

        if (res.body.success) {
          if (connection.bank.connect_mode === bank.connectModes.MODAL) {
            this.saltEdgeLink = res.body.data;
          }
          if (connection.bank.connect_mode === bank.connectModes.NEW_WINDOW) {
            this.redirectLink = res.body.data;
          }
        } else {
          console.log(res.body);
          this.$toasted.error('Ошибка');
        }
      } catch (err) {
        console.error(err);
        this.$toasted.error('Ошибка');
      } finally {
        this.disableButtons = false;
      }
    },
    handleCloseModal() {
      this.saltEdgeLink = null;
      this.redirectLink = null;
      this.$emit('bankModalClosed');
    }
  },
  i18n: {
    messages: {
      en: {
        settings: 'Settings',
        emptyTip: 'You can add banks in settings!'
      },
      ru: {
        settings: 'Настройки',
        emptyTip: 'Вы можете подюключить банковские системы в настройках!'
      }
    }
  }
}
</script>